module.exports = __webpack_public_path__ + "static/media/12.ce55fd3e.png";